<template>
  <div class="column" :class="columnSize">
    <b-checkbox
      :value="value"
      :true-value="trueValue"
      false-value
      @input="onInput"
    >
      {{ label }}
    </b-checkbox>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String
    },
    value: {
      type: Boolean | String
    },
    trueValue: {
      type: Boolean | String,
      default: true
    },
    falseValue: {
      type: Boolean | String,
      default: false
    },
    columnSize: {
      type: Object | String,
      default: "is-12"
    }
  },
  methods: {
    onInput(value) {
      this.$emit("input", value);
      this.$emit("update:value", value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/OrderFilter/Field/OrderFilterFieldCheckbox.vue